@import 'styles/mixins';
@import 'styles/variables';

.root {
  @include shadow-3;
  @include z-index(groupsRightHandSidebar);
  position: fixed;
  top: $action-bar-height;
  bottom: 0;
  right: 0;
  width: 320px;
  background-color: white;
  border-left: 1px solid rgba($gray-10, 0.5);
  overflow-y: scroll;

  @media (max-width: $docRightRailSmallWidth_deprecated) {
    top: 0;
    width: 100%;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  margin: 8px 0;
  align-items: flex-start;

  h2 {
    margin: 0;
    @include ui-lg-bold;
    color: $gray-90;
  }
}

.closeButton {
  height: 24px;
  justify-content: end;
}
